"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclAction = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let AclAction = class AclAction {
    constructor(id, name, description, createdBy, updatedBy, actionKey) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.actionKey = actionKey;
    }
};
exports.AclAction = AclAction;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], AclAction.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "name",
        type: "varchar",
        length: 50,
        unique: true,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], AclAction.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], AclAction.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "action_key", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclAction.prototype, "actionKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], AclAction.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], AclAction.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclAction.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclAction.prototype, "updatedBy", void 0);
exports.AclAction = AclAction = tslib_1.__decorate([
    (0, typeorm_1.Entity)("acl_actions"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String, String])
], AclAction);
